import axios from 'axios'
import qs from 'qs'

// API服务器地址

// 本地测试
//let SERVICE_URL = '//127.0.0.1:18700/'

//let SERVICE_URL = '//47.242.135.72:18700/'
// 美国
let SERVICE_URL = 'http://iwsmanageapi.efercro.com:18700/'
// 欧洲
//let SERVICE_URL = 'http://eumanageapi.efercro.com:18700/'
//let SERVICE_URL = '//3.71.4.189:18700/'

//es API服务器地址
//let BI_SERVICE_URL = 'http://127.0.0.1:19095'
// aws 美东/
let BI_SERVICE_URL = '//44.203.109.189:19095'
// 测试
//let BI_SERVICE_URL = '//47.242.135.72:19095'
// aws 欧洲
// let BI_SERVICE_URL = '//3.71.4.189:19095'


const axiosX = axios.create({
  baseURL: SERVICE_URL
})

const axiosJSON = axios.create({
  baseURL: SERVICE_URL
})

const axiosBIJSON = axios.create({
  baseURL: BI_SERVICE_URL
})


const axiosHead = axios.create({
  baseURL: SERVICE_URL
})

axiosJSON.defaults.timeout = 600000

axiosBIJSON.defaults.timeout = 600000


axiosBIJSON.interceptors.request.use(function (config) {
 config.headers['Content-Type'] = 'application/json;charset=UTF-8',
 config.headers['token'] = window.sessionStorage.token
 return config;
}, function (error) {
 return Promise.reject(error);
});

axiosBIJSON.interceptors.response.use(
  response => {
    if (response.data.code === '1009' || response.data.code === '1004' || response.data.code === '1003') {
      window.location.href = '/'
    }
    return response
  },error => {
    return Promise.reject(error.response)
})

axiosJSON.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8',
      config.headers['token'] = window.sessionStorage.token
  return config;
}, function (error) {
  return Promise.reject(error);
});

axiosJSON.interceptors.response.use(
    response => {
      if (response.data.code === '1009' || response.data.code === '1004' || response.data.code === '1003') {
        window.location.href = '/'
      }
      return response
    },error => {
      return Promise.reject(error.response)
    })

// 添加请求拦截器
axiosX.interceptors.request.use(function (config) {
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded',
  config.headers['token'] = window.sessionStorage.token
  // openLoading()
  return config;
}, function (error) {
  return Promise.reject(error);
});

axiosX.interceptors.response.use(
  response => {
    // closeLoading()
    if (response.data.code === '1009' || response.data.code === '1004' || response.data.code === '1003') {
      window.location.href = '/'
    }
    return response
  },error => {
    // closeLoading()
    return Promise.reject(error.response)
})

axiosHead.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'multipart/form-data'
  config.headers['token'] = window.sessionStorage.token
  return config;
}, function (error) {
  return Promise.reject(error);
});

axiosHead.interceptors.response.use(
  response => {
    if (response.data.code === '1009' || response.data.code === '1004' || response.data.code === '1003') {
      window.location.href = '/'
    }
    return response
  },error => {
    return Promise.reject(error.response)
  })


const XHR = () => {
  const sucFun = res => {
    return res.data
  }

  const errFun = (res) => {
    let r = {
      msg: '请求失败,请稍后重试！'
    }
    return r
  }

  return { sucFun, errFun }
}

// POST
const axiosPost = function (url = '', data = {}) {
  let { sucFun, errFun } = XHR()
  let reqData = qs.stringify({ ...data })
  return axiosX.post(url, reqData).then(sucFun).catch(errFun)
}

// POST
const axiosBIJSONPost = function (url = '', data = {}) {
  let { sucFun, errFun } = XHR()
  return axiosBIJSON.post(url, data).then(sucFun).catch(errFun)
}
const axiosPostAndHead = function (url = '', data = {}) {
  let { sucFun, errFun } = XHR()
  return axiosHead.post(url, data)
}

// POST
const axiosJSONPost = function (url = '', data = {}) {
    let { sucFun, errFun } = XHR()
    return axiosJSON.post(url, data).then(sucFun).catch(errFun)
}

// GET
const axiosGet = function (url = '', data = {}) {
  let { sucFun, errFun } = XHR()
  let params = {
    params: { ...data }
  }
  return axiosX.get(url, params).then(sucFun).catch(errFun)
}

export default (Vue) => {
  Vue.prototype.$axios = axios
  Vue.prototype.$axiosGet = axiosGet
  Vue.prototype.$axiosPost = axiosPost
  Vue.prototype.$axiosPostAndHead = axiosPostAndHead
  Vue.prototype.$axiosJSONPost = axiosJSONPost
  Vue.prototype.$baseApi = SERVICE_URL
  Vue.prototype.$fileUploadApi = "//127.0.0.1:18700/"
  Vue.prototype.$basebiApi = BI_SERVICE_URL
  Vue.axios = axios
  Vue.axiosPost = axiosPost
  Vue.axiosJSONPost = axiosJSONPost
  Vue.axiosGet = axiosGet
}
export {axiosGet, axiosPost, axiosJSONPost, axiosBIJSONPost, axiosPostAndHead}



// WEBPACK FOOTER //
// ./src/util/axios.js